import axios from '@/libs/api.request'
// 模板列表
export const apiProducttempList = data => {
  return axios.request({
    url: '/producttemp/list',
    method: 'post',
    data
  })
}
// 详情
export const apiProducttempInfo = data => {
  return axios.request({
    url: `/producttemp/info/${data.id}`,
    method: 'post',
    data
  })
}
// 关联产品
export const apiProducttempRelation = data => {
  return axios.request({
    url: `/producttemp/relation`,
    method: 'post',
    data
  })
}
// 删除
export const apiProducttempDelete = data => {
  return axios.request({
    url: `/producttemp/delete`,
    method: 'post',
    data
  })
}
// 保存
export const apiProducttempSave = data => {
  return axios.request({
    url: `/producttemp/save`,
    method: 'post',
    data
  })
}

// 产品关联保存
export const apiProductRelationSave = data => {
  return axios.request({
    url: `/producttemp/save-relation`,
    method: 'post',
    data
  })
}
// 删除产品关联
export const apiProductRelationDelete = id => {
  return axios.request({
    url: `/producttemp/delete-relation/${id}`,
    method: 'post'
  })
}
// 产品模版查询
export const apiProducttempSearch = data => {
  return axios.request({
    url: `/producttemp/search`,
    method: 'post',
    data
  })
}
// 上传模板源文件
export const apiProducttempUploadFile = data => {
  return axios.request({
    url: `/producttemp/upload-file`,
    method: 'post',
    data
  })
}
// 上传模板源文件
export const apiProductAll = data => {
  return axios.request({
    url: `/product/all`,
    method: 'post',
    data
  })
}
// 获取所有行业
export const apiIndustryAll = data => {
  return axios.request({
    url: `/industry/list`,
    method: 'post',
    data
  })
}
// 行业模版保存
export const apiTempIndustryRelationSave = data => {
  return axios.request({
    url: `/industrytemp/save`,
    method: 'post',
    data
  })
}

// 行业模版保存
export const apiTempIndustryRelationSList = data => {
  return axios.request({
    url: `/industrytemp/bind-list`,
    method: 'post',
    data
  })
}
// 模版产品保存
export const apiTempProductRelationSave = data => {
  return axios.request({
    url: `/producttemp/save-relation-batch`,
    method: 'post',
    data
  })
}

// 获取oss配置
export const apiGetOssPolicy = data => {
  return axios.request({
    url: `/policy`,
    method: 'get',
    data
  })
}
